export default __webpack_public_path__ + "static/media/2050.24d7feb2.png";